import feathers from '@feathersjs/client';
import io from 'socket.io-client';

const socket = io(process.env.REACT_APP_API_URL, {
  transports: ['websocket'],
  forceNew: true
});

const methods = ['_get', '_find', '_create', '_update', '_patch', '_remove'];

export const paramsPositions = {
  get: 1,
  find: 0,
  create: 1,
  update: 2,
  patch: 2,
  remove: 1
};

const property = '__FEATHERS_HEADERS__';

export default (app) => {
  feathers.socketio(socket)(app);

  // Feathers socket client only sends query to the server
  // but not headers. This mixin allows params.headers to piggyback
  // on params.query so that it can be sent to the server.
  // The server will then extract params.headers from params.query
  // in a hook (see server/src/app.hooks.js).
  app.mixins.push(function (service) {
    if (!service.connection || !service.send) {
      // Not a socket service
      return;
    }

    methods.forEach((method) => {
      if (!service[method]) {
        return;
      }

      const position = paramsPositions[method.replace('_', '')];
      const original = service[method];
      service[method] = function (...args) {
        const params = { ...args[position] };
        const query = { ...params.query };
        query[property] = params.headers;
        params.query = query;
        args[position] = params;
        return original.apply(this, args);
      };
    });
  });
};
